






// import React, { useState, useEffect, useCallback } from 'react';

// const EventsCelebrations = () => {
//   const [activeTab, setActiveTab] = useState('events'); // 'events' or 'festivals'
//   const [events, setEvents] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [sendingId, setSendingId] = useState(null); 
//   const [sendingFest, setSendingFest] = useState(null);

//   // Predefined Festival List based on your 2026 schedule
//   const festivals = [
//     { name: "Happy New Year", date: "1st Jan", img: "New Year.png" }, // no image
//     { name: "Makar Sankranti", date: "14th Jan", img: "Makar Sankranti.png" }, // no image  .
//     { name: "Republic Day", date: "26th Jan", img: "Republic Day.png" }, //no image  .
//     { name: "Maha Shivratri", date: "15th Feb", img: "Maha Shivratri.png" }, //no image
//     { name: "Holi", date: "4th March", img: "Holi.png" },  // working
//     { name: "Women's Day", date: "8th March", img: "Womens day.png" }, // working
//     { name: "Gudi Padwa", date: "19th Mar", img: "Gudi Padwa.png" },  // working
//     { name: "Guru Purnima", date: "10th July", img: "Guru Purnima.png" },  // working
//    { name: "Independence Day", date: "15th Aug", img: "Independence day.png" },  // working
//     { name: "Raksha Bandhan", date: "17th Aug", img: "Raksha Bandhan.png" },  //no image 
//     { name: "Krishna Janmashtami", date: "25th Aug", img: "Janmashtami.png" },  // no image
//     { name: "Ganesh Chaturti", date: "3rd Sep", img: "Gnesh Chaturti.png" },  // working
//     { name: "Navratri", date: "2nd to 10th Oct", img: "Navaratri.png" }, // working
//    { name: "Gandhi Jayanti", date: "2nd Oct", img: "Gandi Jayanti.png" }, // working
//     { name: "Dussehra", date: "11th Oct", img: "Dussehra.png" },   // working
//     { name: "Happy Diwali", date: "20th Oct", img: "Diwali.png" },  // working
//     { name: "Happy Christmas", date: "25th Dec", img: "Christmas.png" },  // workinh
//   ];

//   const fetchEvents = useCallback(async () => {
//     try {
//       const res = await fetch('/gt-api/get_celebrations.php');
//       const data = await res.json();
//       if (data.success) setEvents(data.data);
//     } catch (err) {
//       console.error("Error fetching celebrations:", err);
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     fetchEvents();
//     const midnightCheck = setInterval(() => {
//       const now = new Date();
//       if (now.getHours() === 0 && now.getMinutes() === 0) {
//         fetchEvents(); 
//       }
//     }, 60000);
//     return () => clearInterval(midnightCheck);
//   }, [fetchEvents]);

//   // Handle Daily Birthday/Anniversary Email
//   const handleSendEmail = async (emp) => {
//     setSendingId(emp.EmpId); 
//     try {
//       const response = await fetch('/gt-api/send_celebration_wish.php', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           email: emp.EmailId,
//           name: emp.fullName,
//           type: emp.type,
//           years: emp.years 
//         }),
//       });
//       const result = await response.json();
//       if (result.success) alert(`Wish successfully sent to ${emp.fullName}!`);
//       else alert(`Failed: ${result.message}`);
//     } catch (error) {
//       alert("Network error: Could not reach server.");
//     } finally {
//       setSendingId(null); 
//     }
//   };

//   // Handle Festival Broadcast Email to ALL Employees
//   const handleSendFestival = async (fest) => {
//     if (!window.confirm(`Are you sure you want to send ${fest.name} wishes to ALL employees?`)) return;

//     setSendingFest(fest.name);
//     try {
//       const response = await fetch('/gt-api/send_festival_wish.php', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           festivalName: fest.name,
//           imageName: fest.img
//         }),
//       });
//       const result = await response.json();
//       if (result.success) {
//         alert(`Success! Broadcast sent to ${result.sent} employees.`);
//       } else {
//         alert(`Error: ${result.message}`);
//       }
//     } catch (error) {
//       alert("Network error: Could not reach server.");
//     } finally {
//       setSendingFest(null);
//     }
//   };

//   return (
//     <div className="okr-glass-card" style={{ padding: '25px', color: '#fff' }}>
//       {/* Tab Header */}
//       <div style={{ display: 'flex', gap: '15px', marginBottom: '25px', borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '15px' }}>
//         <button 
//           onClick={() => setActiveTab('events')} 
//           style={{ 
//             background: activeTab === 'events' ? '#2196F3' : 'transparent', 
//             color: '#fff', border: '1px solid #2196F3', padding: '8px 16px', borderRadius: '20px', cursor: 'pointer', transition: '0.3s' 
//           }}>📅 Daily Events</button>
//         <button 
//           onClick={() => setActiveTab('festivals')} 
//           style={{ 
//             background: activeTab === 'festivals' ? '#2196F3' : 'transparent', 
//             color: '#fff', border: '1px solid #2196F3', padding: '8px 16px', borderRadius: '20px', cursor: 'pointer', transition: '0.3s' 
//           }}>🏮 Festival Broadcast</button>
//       </div>

//       {activeTab === 'events' ? (
//         <>
//           <h2 className="blue-gradient-text">🎉 Today's Events</h2>
//           <p style={{ opacity: 0.6 }}>Birthdays and work anniversaries for today.</p>

//           {loading ? <p>Loading...</p> : (
//             <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '20px', marginTop: '20px' }}>
//               {events.length > 0 ? events.map((emp) => (
//                 <div key={emp.EmpId} style={{ background: 'rgba(255,255,255,0.07)', padding: '20px', borderRadius: '12px', borderLeft: emp.isBirthday ? '4px solid #ff4081' : '4px solid #00bcd4' }}>
//                   <div style={{ fontSize: '1.5rem' }}>{emp.isBirthday ? '🎂' : '🎊'}</div>
//                   <h4 style={{ margin: '10px 0 5px 0' }}>{emp.fullName}</h4>
//                   <p style={{ color: emp.isBirthday ? '#ff4081' : '#00bcd4', fontSize: '0.85rem', fontWeight: 'bold' }}>
//                     {emp.isBirthday ? "IT'S THEIR BIRTHDAY!" : `COMPLETED ${emp.years} YEAR(S)`}
//                   </p>
//                   <p style={{ fontSize: '0.75rem', opacity: 0.5 }}>{emp.Department} Team</p>
//                   <button onClick={() => handleSendEmail(emp)} disabled={sendingId === emp.EmpId}
//                     style={{ marginTop: '15px', width: '100%', padding: '8px', background: sendingId === emp.EmpId ? '#555' : '#2196F3', border: 'none', borderRadius: '5px', color: '#fff', cursor: 'pointer' }}>
//                     {sendingId === emp.EmpId ? "SENDING..." : "WISH THEM ✉️"}
//                   </button>
//                 </div>
//               )) : <p style={{ opacity: 0.5 }}>No events today.</p>}
//             </div>
//           )}
//         </>
//       ) : (
//         <>
//           <h2 className="blue-gradient-text">🏮 Festival Broadcast</h2>
//           <p style={{ opacity: 0.6 }}>Send festival greetings to all employees at once.</p>

//           <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '15px', marginTop: '20px' }}>
//             {festivals.map((fest) => (
//               <div key={fest.name} style={{ background: 'rgba(255,255,255,0.07)', padding: '15px', borderRadius: '10px', textAlign: 'center', border: '1px solid rgba(255,255,255,0.1)' }}>
//                 <h4 style={{ margin: '0 0 5px 0' }}>{fest.name}</h4>
//                 <p style={{ fontSize: '0.8rem', color: '#00bcd4', marginBottom: '10px' }}>{fest.date}</p>
//                 <button 
//                   onClick={() => handleSendFestival(fest)} 
//                   disabled={sendingFest === fest.name}
//                   style={{ width: '100%', padding: '6px', background: sendingFest === fest.name ? '#555' : '#4CAF50', border: 'none', borderRadius: '4px', color: '#fff', cursor: 'pointer', fontWeight: '600' }}>
//                   {sendingFest === fest.name ? "BROADCASTING..." : "SEND TO ALL ✉️"}
//                 </button>
//               </div>
//             ))}
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default EventsCelebrations;


















// import React, { useState, useEffect, useCallback } from 'react';

// import '../styles/EventCelebrations.css';


// const EventsCelebrations = () => {
//   const [festivals, setFestivals] = useState([]);
//   const [activeTab, setActiveTab] = useState('events'); // 'events' or 'festivals'
//   const [events, setEvents] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [sendingId, setSendingId] = useState(null);
//   const [sendingFest, setSendingFest] = useState(null);
//   const [sentFestivals, setSentFestivals] = useState([]);
//   const [previewImage, setPreviewImage] = useState(null);
//   const [newFestival, setNewFestival] = useState({
//     name: '',
//     date: '',
//     image: null
//   });


//   const fetchEvents = useCallback(async () => {
//     try {
//       const res = await fetch('/gt-api/get_celebrations.php');
//       const data = await res.json();
//       if (data.success) setEvents(data.data);
//     } catch (err) {
//       console.error("Error fetching celebrations:", err);
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     fetchEvents();
//     const midnightCheck = setInterval(() => {
//       const now = new Date();
//       if (now.getHours() === 0 && now.getMinutes() === 0) {
//         fetchEvents();
//       }
//     }, 60000);
//     return () => clearInterval(midnightCheck);
//   }, [fetchEvents]);

//   useEffect(() => {
//     fetch('/gt-api/get_festivals.php')
//       .then(res => res.json())
//       .then(data => {
//         if (data.success) {
//           setFestivals(data.data);
//         }
//       });
//   }, []);

//   // Handle Daily Birthday/Anniversary Email
//   const handleSendEmail = async (emp) => {
//     setSendingId(emp.EmpId);
//     try {
//       const response = await fetch('/gt-api/send_celebration_wish.php', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           email: emp.EmailId,
//           name: emp.fullName,
//           type: emp.type,
//           years: emp.years
//         }),
//       });
//       const result = await response.json();
//       if (result.success) alert(`Wish successfully sent to ${emp.fullName}!`);
//       else alert(`Failed: ${result.message}`);
//     } catch (error) {
//       alert("Network error: Could not reach server.");
//     } finally {
//       setSendingId(null);
//     }
//   };

//   // Handle Festival Broadcast Email to ALL Employees
//   const handleSendFestival = async (fest) => {
//     if (!window.confirm(`Are you sure you want to send ${fest.name} wishes to ALL employees?`)) return;

//     setSendingFest(fest.name);
//     try {
//       const response = await fetch('/gt-api/send_festival_wish.php', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           festivalName: fest.name,
//           imageName: fest.image
//         }),
//       });
//       const result = await response.json();
//       if (result.success) {
//         alert(`Success! Broadcast sent to ${result.sent} employees.`);
//         setSentFestivals(prev => [...prev, fest.name]);
//       } else {
//         alert(`Error: ${result.message}`);
//       }
//     } catch (error) {
//       alert("Network error: Could not reach server.");
//     } finally {
//       setSendingFest(null);
//     }
//   };

//   return (
//     <div className="okr-glass-card" style={{ padding: '25px', color: '#fff' }}>
//       {/* Tab Header */}
//       <div style={{ display: 'flex', gap: '15px', marginBottom: '25px', borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '15px' }}>
//         <button
//           onClick={() => setActiveTab('events')}
//           style={{
//             background: activeTab === 'events' ? '#2196F3' : 'transparent',
//             color: '#fff', border: '1px solid #2196F3', padding: '8px 16px', borderRadius: '20px', cursor: 'pointer', transition: '0.3s'
//           }}>📅 Daily Events</button>
//         <button
//           onClick={() => setActiveTab('festivals')}
//           style={{
//             background: activeTab === 'festivals' ? '#2196F3' : 'transparent',
//             color: '#fff', border: '1px solid #2196F3', padding: '8px 16px', borderRadius: '20px', cursor: 'pointer', transition: '0.3s'
//           }}>🏮 Festival Broadcast</button>
//       </div>

//       {activeTab === 'events' ? (
//         <>
//           <h2 className="blue-gradient-text">🎉 Today's Events</h2>
//           <p style={{ opacity: 0.6 }}>Birthdays and work anniversaries for today.</p>

//           {loading ? <p>Loading...</p> : (
//             <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '20px', marginTop: '20px' }}>
//               {events.length > 0 ? events.map((emp) => (
//                 <div key={emp.EmpId} style={{ background: 'rgba(255,255,255,0.07)', padding: '20px', borderRadius: '12px', borderLeft: emp.isBirthday ? '4px solid #ff4081' : '4px solid #00bcd4' }}>
//                   <div style={{ fontSize: '1.5rem' }}>{emp.isBirthday ? '🎂' : '🎊'}</div>
//                   <h4 style={{ margin: '10px 0 5px 0' }}>{emp.fullName}</h4>
//                   <p style={{ color: emp.isBirthday ? '#ff4081' : '#00bcd4', fontSize: '0.85rem', fontWeight: 'bold' }}>
//                     {emp.isBirthday ? "IT'S THEIR BIRTHDAY!" : `COMPLETED ${emp.years} YEAR(S)`}
//                   </p>
//                   <p style={{ fontSize: '0.75rem', opacity: 0.5 }}>{emp.Department} Team</p>
//                   <button onClick={() => handleSendEmail(emp)} disabled={sendingId === emp.EmpId}
//                     style={{ marginTop: '15px', width: '100%', padding: '8px', background: sendingId === emp.EmpId ? '#555' : '#2196F3', border: 'none', borderRadius: '5px', color: '#fff', cursor: 'pointer' }}>
//                     {sendingId === emp.EmpId ? "SENDING..." : "WISH THEM ✉️"}
//                   </button>
//                 </div>
//               )) : <p style={{ opacity: 0.5 }}>No events today.</p>}
//             </div>
//           )}
//         </>
//       ) : (
//         <>
//           <h2 className="blue-gradient-text">🏮 Festival Broadcast</h2>
//           <div className="add-festival-container">

//             <input
//               type="text"
//               placeholder="Festival Name"
//               onChange={(e) => setNewFestival(prev => ({ ...prev, name: e.target.value }))}
//             />

//             <input
//               type="text"
//               placeholder="Date"
//               onChange={(e) => setNewFestival(prev => ({ ...prev, date: e.target.value }))}
//             />

//             <input
//               type="file"
//               onChange={(e) => setNewFestival(prev => ({ ...prev, image: e.target.files[0] }))}
//             />

//             <button className="add-festival-btn"
//               onClick={async () => {
//                 if (!newFestival.name || !newFestival.date || !newFestival.image) {
//                   alert("Fill all fields");
//                   return;
//                 }

//                 const formData = new FormData();
//                 formData.append("name", newFestival.name);
//                 formData.append("date", newFestival.date);
//                 formData.append("image", newFestival.image);

//                 const res = await fetch('/gt-api/add_festival.php', {
//                   method: 'POST',
//                   body: formData
//                 });

//                 const result = await res.json();

//                 if (result.success) {
//                   alert("Festival added!");
//                   window.location.reload();
//                 }
//               }}
//             >
//               ➕ Add Festival
//             </button>

//           </div>
//           <p style={{ opacity: 0.6 }}>Send festival greetings to all employees at once.</p>
//           <button
//             onClick={async () => {
//               const name = prompt("Festival Name:");
//               const date = prompt("Date:");
//               const image = prompt("Image name (from assets folder)");

//               if (!name || !date || !image) return;

//               const res = await fetch('/gt-api/add_festival.php', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({ name, date, image })
//               });

//               const result = await res.json();

//               if (result.success) {
//                 alert("Festival added!");
//                 window.location.reload();
//               }
//             }}
//             style={{
//               marginBottom: '15px',
//               padding: '10px',
//               background: '#9c27b0',
//               border: 'none',
//               borderRadius: '6px',
//               color: '#fff',
//               cursor: 'pointer'
//             }}
//           >
//             {/* ➕ Add Festival */}


//           </button>

//           <div className="festival-grid" style={{
//             display: 'grid',
//             gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
//             gap: '15px',
//             marginTop: '20px'
//           }}>
//             {festivals.map((fest) => (
//               <div key={fest.name} style={{
//                 background: 'rgba(255,255,255,0.07)',
//                 padding: '15px',
//                 borderRadius: '10px',
//                 textAlign: 'center',
//                 border: '1px solid rgba(255,255,255,0.1)'
//               }}>

//                 <img
//                   src={`/gt-api/assets/${fest.image}`}
//                   alt={fest.name}
//                   onClick={() => setPreviewImage(fest.image)}
//                   style={{
//                     width: '100%',
//                     height: '120px',
//                     objectFit: 'cover',
//                     borderRadius: '8px',
//                     marginBottom: '10px',
//                     cursor: 'pointer'
//                   }}
//                 />

//                 <h4>{fest.name}</h4>
//                 <p>{fest.date}</p>

//                 {/* 🔥 ADD BUTTON RIGHT HERE */}
//                 <button
//                   onClick={() => handleSendFestival(fest)}
//                   disabled={sendingFest === fest.name || sentFestivals.includes(fest.name)}
//                   style={{
//                     width: '100%',
//                     padding: '6px',
//                     background: sentFestivals.includes(fest.name)
//                       ? '#2e7d32'   // green for sent
//                       : sendingFest === fest.name
//                         ? '#555'
//                         : '#4CAF50',
//                     border: 'none',
//                     borderRadius: '4px',
//                     color: '#fff',
//                     cursor: 'pointer',
//                     fontWeight: '600'
//                   }}>

//                   {sentFestivals.includes(fest.name)
//                     ? "SENT ✅"
//                     : sendingFest === fest.name
//                       ? "BROADCASTING..."
//                       : "SEND TO ALL ✉️"}
//                 </button>
//                 <label className="custom-file-upload">
//                   📤 Change Image
//                   <input
//                     type="file"
//                     onChange={async (e) => {
//                       const file = e.target.files[0];
//                       if (!file) return;

//                       const formData = new FormData();
//                       formData.append("id", fest.id);
//                       formData.append("image", file);

//                       const res = await fetch('/gt-api/update_festival.php', {
//                         method: 'POST',
//                         body: formData
//                       });

//                       const result = await res.json();

//                       if (result.success) {
//                         alert("Updated!");
//                         window.location.reload();
//                       }
//                     }}
//                   />
//                 </label>
//                 {/* 🔥 ADD DELETE BUTTON HERE */}
//                 <button
//                   onClick={async () => {
//                     if (!window.confirm("Delete this festival?")) return;

//                     const res = await fetch('/gt-api/delete_festival.php', {
//                       method: 'POST',
//                       headers: { 'Content-Type': 'application/json' },
//                       body: JSON.stringify({
//                         id: fest.id,
//                         image: fest.image
//                       })
//                     });

//                     const result = await res.json();

//                     if (result.success) {
//                       alert("Deleted!");
//                       setFestivals(prev => prev.filter(f => f.id !== fest.id));
//                     }
//                   }}
//                   style={{
//                     marginTop: '8px',
//                     padding: '5px 10px',
//                     background: 'rgba(229,57,53,0.15)',
//                     border: '1px solid #e53935',
//                     borderRadius: '20px',
//                     color: '#ff6b6b',
//                     cursor: 'pointer',
//                     fontSize: '12px',
//                     width: 'auto',
//                     display: 'inline-block'
//                   }}
//                 >
//                   🗑 Delete
//                 </button>


//               </div>
//             ))}

//             {previewImage && (
//               <div
//                 className="image-preview-overlay"
//                 onClick={() => setPreviewImage(null)}   // 🔥 CLOSE ON CLICK ANYWHERE
//               >
//                 <span
//                   className="close-btn"
//                   onClick={() => setPreviewImage(null)}
//                 >
//                   ✖
//                 </span>

//                 <img
//                   src={`/gt-api/assets/${previewImage}`}
//                   className="preview-image"
//                   onClick={(e) => e.stopPropagation()}  // 🔥 PREVENT IMAGE CLICK FROM CLOSING
//                 />
//               </div>
//             )}
//           </div>
//         </>
//       )
//       }
//     </div>
//   );
// };

// export default EventsCelebrations;



















// import React, { useState, useEffect, useCallback } from 'react';

// import '../styles/EventCelebrations.css';


// const EventsCelebrations = () => {
//   const [festivals, setFestivals] = useState([]);
//   const [activeTab, setActiveTab] = useState('events'); // 'events' or 'festivals'
//   const [events, setEvents] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [sendingId, setSendingId] = useState(null);
//   const [sendingFest, setSendingFest] = useState(null);
//   const [sentFestivals, setSentFestivals] = useState([]);
//   const [previewImage, setPreviewImage] = useState(null);
//   const [newFestival, setNewFestival] = useState({
//     name: '',
//     date: '',
//     image: null
//   });


//   const fetchEvents = useCallback(async () => {
//     try {
//       const res = await fetch('/gt-api/get_celebrations.php', {
//         credentials: "include"
//       });
//       const data = await res.json();
//       console.log("🔥 API RESPONSE:", data);
//       if (data.success) setEvents(data.data);
//     } catch (err) {
//       console.error("Error fetching celebrations:", err);
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     fetchEvents();
//     const midnightCheck = setInterval(() => {
//       const now = new Date();
//       if (now.getHours() === 0 && now.getMinutes() === 0) {
//         fetchEvents();
//       }
//     }, 60000);
//     return () => clearInterval(midnightCheck);
//   }, [fetchEvents]);

//   useEffect(() => {
//     fetch('/gt-api/get_festivals.php', {
//       credentials: "include"
//     })
//       .then(res => res.json())
//       .then(data => {
//         if (data.success) {
//           setFestivals(data.data);
//         }
//       });
//   }, []);

//   // Handle Daily Birthday/Anniversary Email
//   const handleSendEmail = async (emp) => {
//     setSendingId(emp.EmpId);
//     try {
//       const response = await fetch('/gt-api/send_celebration_wish.php', {
//         method: 'POST',
//           credentials: "include",
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           email: emp.EmailId,
//           name: emp.fullName,
//           type: emp.type,
//           years: emp.years
//         }),
//       });
//       const result = await response.json();
//       if (result.success) alert(`Wish successfully sent to ${emp.fullName}!`);
//       else alert(`Failed: ${result.message}`);
//     } catch (error) {
//       alert("Network error: Could not reach server.");
//     } finally {
//       setSendingId(null);
//     }
//   };

//   // Handle Festival Broadcast Email to ALL Employees
//   const handleSendFestival = async (fest) => {
//     if (!window.confirm(`Are you sure you want to send ${fest.name} wishes to ALL employees?`)) return;

//     setSendingFest(fest.name);
//     try {
//       const response = await fetch('/gt-api/send_festival_wish.php', {
//         method: 'POST',
//           credentials: "include",
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           festivalName: fest.name,
//           imageName: fest.image
//         }),
//       });
//       const result = await response.json();
//       if (result.success) {
//         alert(`Success! Broadcast sent to ${result.sent} employees.`);
//         setSentFestivals(prev => [...prev, fest.name]);
//       } else {
//         alert(`Error: ${result.message}`);
//       }
//     } catch (error) {
//       alert("Network error: Could not reach server.");
//     } finally {
//       setSendingFest(null);
//     }
//   };

//   const [eventImages, setEventImages] = useState({});
//   useEffect(() => {
//     if (events.length > 0) {
//       const imagesMap = {};

//       events.forEach(emp => {
//         if (emp.isBirthday) {
//           const birthdayImages = [
//             "Birthday card 1.jpg",
//             "Birthday card 2.jpg",
//             "Birthday card 3.png",
//             "Birthday card 4.png",
//             "Birthday card 5.png",
//             "Birthday card 6.jpg",
//             "Birthday card 7.jpg",
//             "Birthday card 8.jpg",
//             "Birthday card 9.jpg"
//           ];

//           const randomIndex = Math.floor(Math.random() * birthdayImages.length);
//           imagesMap[emp.EmpId] = birthdayImages[randomIndex];

//         } else {
//           const year = emp.years;

//           if (year >= 5) imagesMap[emp.EmpId] = "anniversary_5.png";
//           else if (year === 4) imagesMap[emp.EmpId] = "anniversary_4.png";
//           else if (year === 3) imagesMap[emp.EmpId] = "anniversary_3.png";
//           else if (year === 2) imagesMap[emp.EmpId] = "anniversary_2.png";
//           else imagesMap[emp.EmpId] = "anniversary_1.png";
//         }
//       });

//       setEventImages(imagesMap);
//     }
//   }, [events]);



//   return (
//     <div className="okr-glass-card" style={{ padding: '25px', color: '#fff' }}>
//       {/* Tab Header */}
//       <div style={{ display: 'flex', gap: '15px', marginBottom: '25px', borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '15px' }}>
//         <button
//           onClick={() => setActiveTab('events')}
//           style={{
//             background: activeTab === 'events' ? '#2196F3' : 'transparent',
//             color: '#fff', border: '1px solid #2196F3', padding: '8px 16px', borderRadius: '20px', cursor: 'pointer', transition: '0.3s'
//           }}>📅 Daily Events</button>
//         <button
//           onClick={() => setActiveTab('festivals')}
//           style={{
//             background: activeTab === 'festivals' ? '#2196F3' : 'transparent',
//             color: '#fff', border: '1px solid #2196F3', padding: '8px 16px', borderRadius: '20px', cursor: 'pointer', transition: '0.3s'
//           }}>🏮 Festival Broadcast</button>
//       </div>

//       {activeTab === 'events' ? (
//         <>
//           <h2 className="blue-gradient-text">🎉 Today's Events</h2>
//           <p style={{ opacity: 0.6 }}>Birthdays and work anniversaries for today.</p>

         
//           {loading ? <p>Loading...</p> : (
//             <div style={{
//               display: 'grid',
//               gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
//               gap: '20px',
//               marginTop: '20px'
//             }}>

//               {events.length > 0 ? events.map((emp) => {

//                 const getEventImage = (emp) => {
//                   if (emp.isBirthday) {
//                     const birthdayImages = [
//                       "Birthday card 1.jpg",
//                       "Birthday card 2.jpg",
//                       "Birthday card 3.png",
//                       "Birthday card 4.png",
//                       "Birthday card 5.png",
//                       "Birthday card 6.jpg",
//                       "Birthday card 7.jpg",
//                       "Birthday card 8.jpg",
//                       "Birthday card 9.jpg"
//                     ];
//                     const randomIndex = Math.floor(Math.random() * birthdayImages.length);
//                     return birthdayImages[randomIndex];
//                   } else {
//                     const year = emp.years;
//                     if (year >= 5) return "anniversary_5.png";
//                     if (year === 4) return "anniversary_4.png";
//                     if (year === 3) return "anniversary_3.png";
//                     if (year === 2) return "anniversary_2.png";
//                     return "anniversary_1.png";
//                   }
//                 };

//                 const imageName = getEventImage(emp);

//                 return (
//                   <div
//                     key={emp.EmpId}
//                     style={{
//                       background: 'rgba(255,255,255,0.07)',
//                       padding: '20px',
//                       borderRadius: '12px',
//                       borderLeft: emp.isBirthday ? '4px solid #ff4081' : '4px solid #00bcd4'
//                     }}
//                   >

//                     {/* 🔥 IMAGE ADDED */}
//                     <img
//                       src={`/gt-api/assets/${eventImages[emp.EmpId]}`}
//                       alt={emp.fullName}
//                       onClick={() => setPreviewImage(eventImages[emp.EmpId])}
//                       style={{
//                         width: '100%',
//                         height: '200px',
//                         objectFit: 'cover',
//                         borderRadius: '10px',
//                         marginBottom: '10px',
//                         cursor: 'pointer' // 🔥 add this
//                       }}
//                     />

//                     <div style={{ fontSize: '1.5rem' }}>
//                       {emp.isBirthday ? '🎂' : '🎊'}
//                     </div>

//                     <h4 style={{ margin: '10px 0 5px 0' }}>
//                       {emp.fullName}
//                     </h4>

//                     <p style={{
//                       color: emp.isBirthday ? '#ff4081' : '#00bcd4',
//                       fontSize: '0.85rem',
//                       fontWeight: 'bold'
//                     }}>
//                       {emp.isBirthday
//                         ? "IT'S THEIR BIRTHDAY!"
//                         : `COMPLETED ${emp.years} YEAR(S)`
//                       }
//                     </p>

//                     <p style={{ fontSize: '0.75rem', opacity: 0.5 }}>
//                       {emp.Department} Team
//                     </p>

//                     <button
//                       onClick={() => handleSendEmail(emp)}
//                       disabled={sendingId === emp.EmpId}
//                       style={{
//                         marginTop: '15px',
//                         width: '100%',
//                         padding: '8px',
//                         background: sendingId === emp.EmpId ? '#555' : '#2196F3',
//                         border: 'none',
//                         borderRadius: '5px',
//                         color: '#fff',
//                         cursor: 'pointer'
//                       }}
//                     >
//                       {sendingId === emp.EmpId ? "SENDING..." : "WISH THEM ✉️"}
//                     </button>

//                   </div>
//                 );

//               }) : (
//                 <p style={{ opacity: 0.5 }}>No events today.</p>
//               )}

//             </div>
//           )}
//         </>
//       ) : (
//         <>
//           <h2 className="blue-gradient-text">🏮 Festival Broadcast</h2>
//           <div className="add-festival-container">

//             <input
//               type="text"
//               placeholder="Festival Name"
//               onChange={(e) => setNewFestival(prev => ({ ...prev, name: e.target.value }))}
//             />

//             <input
//               type="text"
//               placeholder="Date"
//               onChange={(e) => setNewFestival(prev => ({ ...prev, date: e.target.value }))}
//             />

//             <input
//               type="file"
//               onChange={(e) => setNewFestival(prev => ({ ...prev, image: e.target.files[0] }))}
//             />

//             <button className="add-festival-btn"
//               onClick={async () => {
//                 if (!newFestival.name || !newFestival.date || !newFestival.image) {
//                   alert("Fill all fields");
//                   return;
//                 }

//                 const formData = new FormData();
//                 formData.append("name", newFestival.name);
//                 formData.append("date", newFestival.date);
//                 formData.append("image", newFestival.image);

//                 const res = await fetch('/gt-api/add_festival.php', {
//                   method: 'POST',
//                     credentials: "include",
//                   body: formData
//                 });

//                 const result = await res.json();

//                 if (result.success) {
//                   alert("Festival added!");
//                   window.location.reload();
//                 }
//               }}
//             >
//               ➕ Add Festival
//             </button>

//           </div>
//           <p style={{ opacity: 0.6 }}>Send festival greetings to all employees at once.</p>
//           <button
//             onClick={async () => {
//               const name = prompt("Festival Name:");
//               const date = prompt("Date:");
//               const image = prompt("Image name (from assets folder)");

//               if (!name || !date || !image) return;

//               const res = await fetch('/gt-api/add_festival.php', {
//                 method: 'POST',
//                   credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({ name, date, image })
//               });

//               const result = await res.json();

//               if (result.success) {
//                 alert("Festival added!");
//                 window.location.reload();
//               }
//             }}
//             style={{
//               marginBottom: '15px',
//               padding: '10px',
//               background: '#9c27b0',
//               border: 'none',
//               borderRadius: '6px',
//               color: '#fff',
//               cursor: 'pointer'
//             }}
//           >
//             {/* ➕ Add Festival */}


//           </button>

//           <div className="festival-grid" style={{
//             display: 'grid',
//             gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
//             gap: '15px',
//             marginTop: '20px'
//           }}>
//             {festivals.map((fest) => (
//               <div key={fest.name} style={{
//                 background: 'rgba(255,255,255,0.07)',
//                 padding: '15px',
//                 borderRadius: '10px',
//                 textAlign: 'center',
//                 border: '1px solid rgba(255,255,255,0.1)'
//               }}>

//                 <img
//                   src={`/gt-api/assets/${fest.image}`}
//                   alt={fest.name}
//                   onClick={() => setPreviewImage(fest.image)}
//                   style={{
//                     width: '100%',
//                     height: '120px',
//                     objectFit: 'cover',
//                     borderRadius: '8px',
//                     marginBottom: '10px',
//                     cursor: 'pointer'
//                   }}
//                 />

//                 <h4>{fest.name}</h4>
//                 <p>{fest.date}</p>

//                 {/* 🔥 ADD BUTTON RIGHT HERE */}
//                 <button
//                   onClick={() => handleSendFestival(fest)}
//                   disabled={sendingFest === fest.name || sentFestivals.includes(fest.name)}
//                   style={{
//                     width: '100%',
//                     padding: '6px',
//                     background: sentFestivals.includes(fest.name)
//                       ? '#2e7d32'   // green for sent
//                       : sendingFest === fest.name
//                         ? '#555'
//                         : '#4CAF50',
//                     border: 'none',
//                     borderRadius: '4px',
//                     color: '#fff',
//                     cursor: 'pointer',
//                     fontWeight: '600'
//                   }}>

//                   {sentFestivals.includes(fest.name)
//                     ? "SENT ✅"
//                     : sendingFest === fest.name
//                       ? "BROADCASTING..."
//                       : "SEND TO ALL ✉️"}
//                 </button>
//                 <label className="custom-file-upload">
//                   📤 Change Image
//                   <input
//                     type="file"
//                     onChange={async (e) => {
//                       const file = e.target.files[0];
//                       if (!file) return;

//                       const formData = new FormData();
//                       formData.append("id", fest.id);
//                       formData.append("image", file);

//                       const res = await fetch('/gt-api/update_festival.php', {
//                         method: 'POST',
//                           credentials: "include",
//                         body: formData
//                       });

//                       const result = await res.json();

//                       if (result.success) {
//                         alert("Updated!");
//                         window.location.reload();
//                       }
//                     }}
//                   />
//                 </label>
//                 {/* 🔥 ADD DELETE BUTTON HERE */}
//                 <button
//                   onClick={async () => {
//                     if (!window.confirm("Delete this festival?")) return;

//                     const res = await fetch('/gt-api/delete_festival.php', {
//                       method: 'POST',
//                         credentials: "include",
//                       headers: { 'Content-Type': 'application/json' },
//                       body: JSON.stringify({
//                         id: fest.id,
//                         image: fest.image
//                       })
//                     });

//                     const result = await res.json();

//                     if (result.success) {
//                       alert("Deleted!");
//                       setFestivals(prev => prev.filter(f => f.id !== fest.id));
//                     }
//                   }}
//                   style={{
//                     marginTop: '8px',
//                     padding: '5px 10px',
//                     background: 'rgba(229,57,53,0.15)',
//                     border: '1px solid #e53935',
//                     borderRadius: '20px',
//                     color: '#ff6b6b',
//                     cursor: 'pointer',
//                     fontSize: '12px',
//                     width: 'auto',
//                     display: 'inline-block'
//                   }}
//                 >
//                   🗑 Delete
//                 </button>


//               </div>
//             ))}

//             {previewImage && (
//               <div
//                 className="image-preview-overlay"
//                 onClick={() => setPreviewImage(null)}   // 🔥 CLOSE ON CLICK ANYWHERE
//               >
//                 <span
//                   className="close-btn"
//                   onClick={() => setPreviewImage(null)}
//                 >
//                   ✖
//                 </span>

//                 <img
//                   src={`/gt-api/assets/${previewImage}`}
//                   className="preview-image"
//                   onClick={(e) => e.stopPropagation()}  // 🔥 PREVENT IMAGE CLICK FROM CLOSING
//                 />
//               </div>
//             )}
//           </div>
//         </>
//       )
//       }


//       {previewImage && (
//         <div
//           onClick={() => setPreviewImage(null)} // 🔥 click outside closes
//           style={{
//             position: 'fixed',
//             top: 0,
//             left: 0,
//             width: '100%',
//             height: '100%',
//             background: 'rgba(0,0,0,0.8)',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             zIndex: 9999
//           }}
//         >

//           {/* ❌ CLOSE BUTTON */}
//           <span
//             onClick={() => setPreviewImage(null)}
//             style={{
//               position: 'absolute',
//               top: '20px',
//               right: '30px',
//               fontSize: '28px',
//               color: '#fff',
//               cursor: 'pointer'
//             }}
//           >
//             ✖
//           </span>

//           {/* IMAGE */}
//           <img
//             src={`/gt-api/assets/${previewImage}`}
//             alt="preview"
//             onClick={(e) => e.stopPropagation()}
//             style={{
//               maxWidth: '80%',     // slightly narrower
//               maxHeight: '98vh',   // 🔥 almost full screen height
//               borderRadius: '12px',
//               boxShadow: '0 0 30px rgba(0,0,0,0.7)'
//             }}
//           />
//         </div>
//       )}

//     </div>
//   );
// };

// export default EventsCelebrations;























// import React, { useState, useEffect, useCallback } from 'react';

// import '../styles/EventCelebrations.css';


// const getTodayKey = () => {
//   const today = new Date();
//   return `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
// };

// const EventsCelebrations = () => {
//   const [festivals, setFestivals] = useState([]);
//   const [activeTab, setActiveTab] = useState('events'); // 'events' or 'festivals'
//   const [events, setEvents] = useState([]);
//   const [todayFestival, setTodayFestival] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [sendingId, setSendingId] = useState(null);
//   const [sendingFest, setSendingFest] = useState(null);

//   const [sentEmailIds, setSentEmailIds] = useState(() => {
//     try {
//       const stored = localStorage.getItem(`sent_emails_${getTodayKey()}`);
//       return stored ? JSON.parse(stored) : [];
//     } catch {
//       return [];
//     }
//   });

//   const [sentFestivals, setSentFestivals] = useState(() => {
//     try {
//       const stored = localStorage.getItem(`sent_festivals_${getTodayKey()}`);
//       return stored ? JSON.parse(stored) : [];
//     } catch {
//       return [];
//     }
//   });

//   const [previewImage, setPreviewImage] = useState(null);
//   const [newFestival, setNewFestival] = useState({
//     name: '',
//     date: '',
//     image: null
//   });


//   const fetchEvents = useCallback(async () => {
//     try {
//       const res = await fetch('/gt-api/get_celebrations.php', {
//         credentials: "include"
//       });
//       const data = await res.json();
//       console.log("🔥 API RESPONSE:", data);
//       if (data.success) setEvents(data.data);
//     } catch (err) {
//       console.error("Error fetching celebrations:", err);
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     fetchEvents();
//     const midnightCheck = setInterval(() => {
//       const now = new Date();
//       if (now.getHours() === 0 && now.getMinutes() === 0) {
//         fetchEvents();
//       }
//     }, 60000);
//     return () => clearInterval(midnightCheck);
//   }, [fetchEvents]);

//   useEffect(() => {
//     fetch('/gt-api/get_festivals.php', {
//       credentials: "include"
//     })
//       .then(res => res.json())
//       .then(data => {
//         console.log("FESTIVALS API DATA:", data);
//         const list = data.festivals || data.data || [];
//         setFestivals(list);
//       })
//       .catch(err => console.error("Error fetching festivals:", err));
//   }, []);

//   const checkIfFestivalIsToday = (festival, daysLeftVal, isTodayFlag) => {
//     if (!festival) return false;
//     if (isTodayFlag === true || daysLeftVal === 0) return true;

//     if (festival.date) {
//       const today = new Date();
//       const currentDay = today.getDate();
//       const currentMonth = today.getMonth();
//       const monthNames = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
//       const currentMonthName = monthNames[currentMonth];

//       const dateLower = String(festival.date).toLowerCase();

//       if (dateLower.includes(currentMonthName) || (currentMonthName === "sep" && dateLower.includes("sept"))) {
//         const rangeMatch = dateLower.match(/(\d+)\s*(?:st|nd|rd|th)?\s*to\s*(\d+)\s*(?:st|nd|rd|th)?/);
//         if (rangeMatch) {
//           const startDay = parseInt(rangeMatch[1], 10);
//           const endDay = parseInt(rangeMatch[2], 10);
//           if (currentDay >= startDay && currentDay <= endDay) {
//             return true;
//           }
//         }

//         const numbers = dateLower.match(/\d+/g);
//         if (numbers) {
//           for (let numStr of numbers) {
//             const num = parseInt(numStr, 10);
//             if (Math.abs(num - currentDay) <= 1) {
//               return true;
//             }
//           }
//         }
//       }
//     }

//     if (typeof daysLeftVal === 'number' && daysLeftVal <= 1) {
//       return true;
//     }

//     return false;
//   };

//   useEffect(() => {
//     fetch('/gt-api/get_upcoming_festival.php', {
//       credentials: "include"
//     })
//       .then(res => res.json())
//       .then(data => {
//         console.log("UPCOMING FESTIVAL DATA:", data);
//         const fest = data.festival || data.upcoming || (data.data && data.data[0]);
//         if (fest) {
//           const normalized = {
//             ...fest,
//             name: fest.name || fest.festival_name || fest.title || "Festival",
//             image: fest.image || fest.img || fest.imageName || ""
//           };
//           setTodayFestival(normalized);
//         }
//       })
//       .catch(err => console.error("Error fetching today's festival:", err));
//   }, []);

//   useEffect(() => {
//     if (festivals.length > 0 && !todayFestival) {
//       const foundToday = festivals.find(f => checkIfFestivalIsToday(f)) || festivals[0];
//       if (foundToday) {
//         setTodayFestival({
//           ...foundToday,
//           name: foundToday.name || foundToday.festival_name || foundToday.title || "Festival",
//           image: foundToday.image || foundToday.img || foundToday.imageName || ""
//         });
//       }
//     }
//   }, [festivals, todayFestival]);

//   // Handle Daily Birthday/Anniversary Email
//   const handleSendEmail = async (emp) => {
//     if (sentEmailIds.includes(emp.EmpId)) {
//       alert(`Wish has already been sent to ${emp.fullName} today!`);
//       return;
//     }

//     setSendingId(emp.EmpId);
//     try {
//       const response = await fetch('/gt-api/send_celebration_wish.php', {
//         method: 'POST',
//           credentials: "include",
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           email: emp.EmailId,
//           name: emp.fullName,
//           type: emp.type,
//           years: emp.years,
//           imageName: eventImages[emp.EmpId] || ""
//         }),
//       });
//       const result = await response.json();
//       if (result.success) {
//         alert(`Wish successfully sent to ${emp.fullName}!`);
//         setSentEmailIds(prev => {
//           const updated = [...prev, emp.EmpId];
//           try {
//             localStorage.setItem(`sent_emails_${getTodayKey()}`, JSON.stringify(updated));
//           } catch (e) { console.error(e); }
//           return updated;
//         });
//       } else {
//         alert(`Failed: ${result.message}`);
//       }
//     } catch (error) {
//       alert("Network error: Could not reach server.");
//     } finally {
//       setSendingId(null);
//     }
//   };

//   // Handle Festival Broadcast Email to ALL Employees
//   const handleSendFestival = async (fest) => {
//     if (sentFestivals.includes(fest.name)) {
//       alert(`${fest.name} wishes have already been sent to employees today!`);
//       return;
//     }

//     if (!window.confirm(`Are you sure you want to send ${fest.name} wishes to ALL employees?`)) return;

//     setSendingFest(fest.name);
//     try {
//       const response = await fetch('/gt-api/send_festival_wish.php', {
//         method: 'POST',
//           credentials: "include",
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           festivalName: fest.name,
//           imageName: fest.image || fest.img || fest.imageName || ""
//         }),
//       });
//       const result = await response.json();
//       if (result.success) {
//         alert(`Success! Broadcast sent to ${result.sent} employees.`);
//         setSentFestivals(prev => {
//           const updated = [...prev, fest.name];
//           try {
//             localStorage.setItem(`sent_festivals_${getTodayKey()}`, JSON.stringify(updated));
//           } catch (e) { console.error(e); }
//           return updated;
//         });
//       } else {
//         alert(`Error: ${result.message}`);
//       }
//     } catch (error) {
//       alert("Network error: Could not reach server.");
//     } finally {
//       setSendingFest(null);
//     }
//   };

//   const [eventImages, setEventImages] = useState({});
//   useEffect(() => {
//     if (events.length > 0) {
//       const imagesMap = {};

//       events.forEach(emp => {
//         if (emp.isBirthday) {
//           const birthdayImages = [
//             "Birthday card 1.jpg",
//             "Birthday card 2.jpg",
//             "Birthday card 3.png",
//             "Birthday card 4.png",
//             "Birthday card 5.png",
//             "Birthday card 6.jpg",
//             "Birthday card 7.jpg",
//             "Birthday card 8.jpg",
//             "Birthday card 9.jpg"
//           ];

//           const randomIndex = Math.floor(Math.random() * birthdayImages.length);
//           imagesMap[emp.EmpId] = birthdayImages[randomIndex];

//         } else {
//           const year = emp.years;

//           if (year >= 5) imagesMap[emp.EmpId] = "anniversary_5.png";
//           else if (year === 4) imagesMap[emp.EmpId] = "anniversary_4.png";
//           else if (year === 3) imagesMap[emp.EmpId] = "anniversary_3.png";
//           else if (year === 2) imagesMap[emp.EmpId] = "anniversary_2.png";
//           else imagesMap[emp.EmpId] = "anniversary_1.png";
//         }
//       });

//       setEventImages(imagesMap);
//     }
//   }, [events]);



//   return (
//     <div className="okr-glass-card" style={{ padding: '25px', color: '#fff' }}>
//       <style>{`
//         @keyframes btnSpin {
//           0% { transform: rotate(0deg); }
//           100% { transform: rotate(360deg); }
//         }
//         .btn-spinner {
//           width: 14px;
//           height: 14px;
//           border: 2px solid rgba(255,255,255,0.4);
//           border-top: 2px solid #ffffff;
//           border-radius: 50%;
//           animation: btnSpin 0.8s linear infinite;
//           display: inline-block;
//         }
//       `}</style>
//       {/* Tab Header */}
//       <div style={{ display: 'flex', gap: '15px', marginBottom: '25px', borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '15px' }}>
//         <button
//           onClick={() => setActiveTab('events')}
//           style={{
//             background: activeTab === 'events' ? '#2196F3' : 'transparent',
//             color: '#fff', border: '1px solid #2196F3', padding: '8px 16px', borderRadius: '20px', cursor: 'pointer', transition: '0.3s'
//           }}>📅 Daily Events</button>
//         <button
//           onClick={() => setActiveTab('festivals')}
//           style={{
//             background: activeTab === 'festivals' ? '#2196F3' : 'transparent',
//             color: '#fff', border: '1px solid #2196F3', padding: '8px 16px', borderRadius: '20px', cursor: 'pointer', transition: '0.3s'
//           }}>🏮 Festival Broadcast</button>
//       </div>

//       {activeTab === 'events' ? (
//         <>
//           <h2 className="blue-gradient-text">🎉 Today's Events</h2>
//           <p style={{ opacity: 0.6 }}>Birthdays, work anniversaries, and festivals for today.</p>

         
//           {loading ? <p>Loading...</p> : (
//             <div style={{
//               display: 'grid',
//               gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
//               gap: '20px',
//               marginTop: '20px'
//             }}>

//               {todayFestival && (
//                 <div
//                   key={`fest-${todayFestival.id || todayFestival.name}`}
//                   style={{
//                     background: 'rgba(255, 152, 0, 0.12)',
//                     padding: '20px',
//                     borderRadius: '12px',
//                     borderLeft: '4px solid #ff9800',
//                     border: '1px solid rgba(255, 152, 0, 0.3)'
//                   }}
//                 >
//                   {todayFestival.image && (
//                     <img
//                       src={`/gt-api/assets/${todayFestival.image}`}
//                       alt={todayFestival.name}
//                       onClick={() => setPreviewImage(todayFestival.image)}
//                       style={{
//                         width: '100%',
//                         height: '200px',
//                         objectFit: 'cover',
//                         borderRadius: '10px',
//                         marginBottom: '10px',
//                         cursor: 'pointer'
//                       }}
//                     />
//                   )}

//                   <div style={{ fontSize: '1.5rem' }}>🏮</div>

//                   <h4 style={{ margin: '10px 0 5px 0' }}>
//                     {todayFestival.name}
//                   </h4>

//                   <p style={{
//                     color: '#ff9800',
//                     fontSize: '0.85rem',
//                     fontWeight: 'bold'
//                   }}>
//                     FESTIVAL TODAY! 🎉
//                   </p>

//                   <p style={{ fontSize: '0.75rem', opacity: 0.5 }}>
//                     Company Festival
//                   </p>

//                   <button
//                     onClick={() => handleSendFestival(todayFestival)}
//                     disabled={sendingFest === todayFestival.name || sentFestivals.includes(todayFestival.name)}
//                     style={{
//                       marginTop: '15px',
//                       width: '100%',
//                       padding: '9px 12px',
//                       background: sentFestivals.includes(todayFestival.name)
//                         ? '#2e7d32'
//                         : sendingFest === todayFestival.name
//                           ? '#555'
//                           : '#ff9800',
//                       border: 'none',
//                       borderRadius: '6px',
//                       color: '#fff',
//                       cursor: (sendingFest === todayFestival.name || sentFestivals.includes(todayFestival.name)) ? 'not-allowed' : 'pointer',
//                       fontWeight: 'bold',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       gap: '8px',
//                       transition: 'background 0.3s'
//                     }}
//                   >
//                     {sendingFest === todayFestival.name ? (
//                       <>
//                         <span className="btn-spinner"></span>
//                         <span>BROADCASTING...</span>
//                       </>
//                     ) : sentFestivals.includes(todayFestival.name) ? (
//                       "SENT ALREADY ✅"
//                     ) : (
//                       "SEND TO ALL ✉️"
//                     )}
//                   </button>
//                 </div>
//               )}

//               {events.length > 0 && events.map((emp) => {

//                 const getEventImage = (emp) => {
//                   if (emp.isBirthday) {
//                     const birthdayImages = [
//                       "Birthday card 1.jpg",
//                       "Birthday card 2.jpg",
//                       "Birthday card 3.png",
//                       "Birthday card 4.png",
//                       "Birthday card 5.png",
//                       "Birthday card 6.jpg",
//                       "Birthday card 7.jpg",
//                       "Birthday card 8.jpg",
//                       "Birthday card 9.jpg"
//                     ];
//                     const randomIndex = Math.floor(Math.random() * birthdayImages.length);
//                     return birthdayImages[randomIndex];
//                   } else {
//                     const year = emp.years;
//                     if (year >= 5) return "anniversary_5.png";
//                     if (year === 4) return "anniversary_4.png";
//                     if (year === 3) return "anniversary_3.png";
//                     if (year === 2) return "anniversary_2.png";
//                     return "anniversary_1.png";
//                   }
//                 };

//                 const imageName = getEventImage(emp);

//                 return (
//                   <div
//                     key={emp.EmpId}
//                     style={{
//                       background: 'rgba(255,255,255,0.07)',
//                       padding: '20px',
//                       borderRadius: '12px',
//                       borderLeft: emp.isBirthday ? '4px solid #ff4081' : '4px solid #00bcd4'
//                     }}
//                   >

//                     {/* 🔥 IMAGE ADDED */}
//                     <img
//                       src={`/gt-api/assets/${eventImages[emp.EmpId]}`}
//                       alt={emp.fullName}
//                       onClick={() => setPreviewImage(eventImages[emp.EmpId])}
//                       style={{
//                         width: '100%',
//                         height: '200px',
//                         objectFit: 'cover',
//                         borderRadius: '10px',
//                         marginBottom: '10px',
//                         cursor: 'pointer' // 🔥 add this
//                       }}
//                     />

//                     <div style={{ fontSize: '1.5rem' }}>
//                       {emp.isBirthday ? '🎂' : '🎊'}
//                     </div>

//                     <h4 style={{ margin: '10px 0 5px 0' }}>
//                       {emp.fullName}
//                     </h4>

//                     <p style={{
//                       color: emp.isBirthday ? '#ff4081' : '#00bcd4',
//                       fontSize: '0.85rem',
//                       fontWeight: 'bold'
//                     }}>
//                       {emp.isBirthday
//                         ? "IT'S THEIR BIRTHDAY!"
//                         : `COMPLETED ${emp.years} YEAR(S)`
//                       }
//                     </p>

//                     <p style={{ fontSize: '0.75rem', opacity: 0.5 }}>
//                       {emp.Department} Team
//                     </p>

//                     <button
//                       onClick={() => handleSendEmail(emp)}
//                       disabled={sendingId === emp.EmpId || sentEmailIds.includes(emp.EmpId)}
//                       style={{
//                         marginTop: '15px',
//                         width: '100%',
//                         padding: '9px 12px',
//                         background: sentEmailIds.includes(emp.EmpId)
//                           ? '#2e7d32'
//                           : sendingId === emp.EmpId
//                             ? '#555'
//                             : '#2196F3',
//                         border: 'none',
//                         borderRadius: '6px',
//                         color: '#fff',
//                         cursor: (sendingId === emp.EmpId || sentEmailIds.includes(emp.EmpId)) ? 'not-allowed' : 'pointer',
//                         fontWeight: '600',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         gap: '8px',
//                         transition: 'background 0.3s'
//                       }}
//                     >
//                       {sendingId === emp.EmpId ? (
//                         <>
//                           <span className="btn-spinner"></span>
//                           <span>SENDING...</span>
//                         </>
//                       ) : sentEmailIds.includes(emp.EmpId) ? (
//                         "SENT ALREADY ✅"
//                       ) : (
//                         "WISH THEM ✉️"
//                       )}
//                     </button>

//                   </div>
//                 );

//               })}

//               {events.length === 0 && !todayFestival && (
//                 <p style={{ opacity: 0.5 }}>No events today.</p>
//               )}

//             </div>
//           )}
//         </>
//       ) : (
//         <>
//           <h2 className="blue-gradient-text">🏮 Festival Broadcast</h2>
//           <div className="add-festival-container">

//             <input
//               type="text"
//               placeholder="Festival Name"
//               onChange={(e) => setNewFestival(prev => ({ ...prev, name: e.target.value }))}
//             />

//             <input
//               type="text"
//               placeholder="Date"
//               onChange={(e) => setNewFestival(prev => ({ ...prev, date: e.target.value }))}
//             />

//             <input
//               type="file"
//               onChange={(e) => setNewFestival(prev => ({ ...prev, image: e.target.files[0] }))}
//             />

//             <button className="add-festival-btn"
//               onClick={async () => {
//                 if (!newFestival.name || !newFestival.date || !newFestival.image) {
//                   alert("Fill all fields");
//                   return;
//                 }

//                 const formData = new FormData();
//                 formData.append("name", newFestival.name);
//                 formData.append("date", newFestival.date);
//                 formData.append("image", newFestival.image);

//                 const res = await fetch('/gt-api/add_festival.php', {
//                   method: 'POST',
//                     credentials: "include",
//                   body: formData
//                 });

//                 const result = await res.json();

//                 if (result.success) {
//                   alert("Festival added!");
//                   window.location.reload();
//                 }
//               }}
//             >
//               ➕ Add Festival
//             </button>

//           </div>
//           <p style={{ opacity: 0.6 }}>Send festival greetings to all employees at once.</p>
//           <button
//             onClick={async () => {
//               const name = prompt("Festival Name:");
//               const date = prompt("Date:");
//               const image = prompt("Image name (from assets folder)");

//               if (!name || !date || !image) return;

//               const res = await fetch('/gt-api/add_festival.php', {
//                 method: 'POST',
//                   credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({ name, date, image })
//               });

//               const result = await res.json();

//               if (result.success) {
//                 alert("Festival added!");
//                 window.location.reload();
//               }
//             }}
//             style={{
//               marginBottom: '15px',
//               padding: '10px',
//               background: '#9c27b0',
//               border: 'none',
//               borderRadius: '6px',
//               color: '#fff',
//               cursor: 'pointer'
//             }}
//           >
//             {/* ➕ Add Festival */}


//           </button>

//           <div className="festival-grid" style={{
//             display: 'grid',
//             gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
//             gap: '15px',
//             marginTop: '20px'
//           }}>
//             {festivals.map((fest) => (
//               <div key={fest.name} style={{
//                 background: 'rgba(255,255,255,0.07)',
//                 padding: '15px',
//                 borderRadius: '10px',
//                 textAlign: 'center',
//                 border: '1px solid rgba(255,255,255,0.1)'
//               }}>

//                 <img
//                   src={`/gt-api/assets/${fest.image}`}
//                   alt={fest.name}
//                   onClick={() => setPreviewImage(fest.image)}
//                   style={{
//                     width: '100%',
//                     height: '120px',
//                     objectFit: 'cover',
//                     borderRadius: '8px',
//                     marginBottom: '10px',
//                     cursor: 'pointer'
//                   }}
//                 />

//                 <h4>{fest.name}</h4>
//                 <p>{fest.date}</p>

//                 {/* 🔥 ADD BUTTON RIGHT HERE */}
//                 <button
//                   onClick={() => handleSendFestival(fest)}
//                   disabled={sendingFest === fest.name || sentFestivals.includes(fest.name)}
//                   style={{
//                     width: '100%',
//                     padding: '8px 12px',
//                     background: sentFestivals.includes(fest.name)
//                       ? '#2e7d32'
//                       : sendingFest === fest.name
//                         ? '#555'
//                         : '#4CAF50',
//                     border: 'none',
//                     borderRadius: '6px',
//                     color: '#fff',
//                     cursor: (sendingFest === fest.name || sentFestivals.includes(fest.name)) ? 'not-allowed' : 'pointer',
//                     fontWeight: '600',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     gap: '8px',
//                     transition: 'background 0.3s'
//                   }}
//                 >
//                   {sendingFest === fest.name ? (
//                     <>
//                       <span className="btn-spinner"></span>
//                       <span>BROADCASTING...</span>
//                     </>
//                   ) : sentFestivals.includes(fest.name) ? (
//                     "SENT ALREADY ✅"
//                   ) : (
//                     "SEND TO ALL ✉️"
//                   )}
//                 </button>
//                 <label className="custom-file-upload">
//                   📤 Change Image
//                   <input
//                     type="file"
//                     onChange={async (e) => {
//                       const file = e.target.files[0];
//                       if (!file) return;

//                       const formData = new FormData();
//                       formData.append("id", fest.id);
//                       formData.append("image", file);

//                       const res = await fetch('/gt-api/update_festival.php', {
//                         method: 'POST',
//                           credentials: "include",
//                         body: formData
//                       });

//                       const result = await res.json();

//                       if (result.success) {
//                         alert("Updated!");
//                         window.location.reload();
//                       }
//                     }}
//                   />
//                 </label>
//                 {/* 🔥 ADD DELETE BUTTON HERE */}
//                 <button
//                   onClick={async () => {
//                     if (!window.confirm("Delete this festival?")) return;

//                     const res = await fetch('/gt-api/delete_festival.php', {
//                       method: 'POST',
//                         credentials: "include",
//                       headers: { 'Content-Type': 'application/json' },
//                       body: JSON.stringify({
//                         id: fest.id,
//                         image: fest.image
//                       })
//                     });

//                     const result = await res.json();

//                     if (result.success) {
//                       alert("Deleted!");
//                       setFestivals(prev => prev.filter(f => f.id !== fest.id));
//                     }
//                   }}
//                   style={{
//                     marginTop: '8px',
//                     padding: '5px 10px',
//                     background: 'rgba(229,57,53,0.15)',
//                     border: '1px solid #e53935',
//                     borderRadius: '20px',
//                     color: '#ff6b6b',
//                     cursor: 'pointer',
//                     fontSize: '12px',
//                     width: 'auto',
//                     display: 'inline-block'
//                   }}
//                 >
//                   🗑 Delete
//                 </button>


//               </div>
//             ))}

//             {previewImage && (
//               <div
//                 className="image-preview-overlay"
//                 onClick={() => setPreviewImage(null)}   // 🔥 CLOSE ON CLICK ANYWHERE
//               >
//                 <span
//                   className="close-btn"
//                   onClick={() => setPreviewImage(null)}
//                 >
//                   ✖
//                 </span>

//                 <img
//                   src={`/gt-api/assets/${previewImage}`}
//                   className="preview-image"
//                   onClick={(e) => e.stopPropagation()}  // 🔥 PREVENT IMAGE CLICK FROM CLOSING
//                 />
//               </div>
//             )}
//           </div>
//         </>
//       )
//       }


//       {previewImage && (
//         <div
//           onClick={() => setPreviewImage(null)} // 🔥 click outside closes
//           style={{
//             position: 'fixed',
//             top: 0,
//             left: 0,
//             width: '100%',
//             height: '100%',
//             background: 'rgba(0,0,0,0.8)',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             zIndex: 9999
//           }}
//         >

//           {/* ❌ CLOSE BUTTON */}
//           <span
//             onClick={() => setPreviewImage(null)}
//             style={{
//               position: 'absolute',
//               top: '20px',
//               right: '30px',
//               fontSize: '28px',
//               color: '#fff',
//               cursor: 'pointer'
//             }}
//           >
//             ✖
//           </span>

//           {/* IMAGE */}
//           <img
//             src={`/gt-api/assets/${previewImage}`}
//             alt="preview"
//             onClick={(e) => e.stopPropagation()}
//             style={{
//               maxWidth: '80%',     // slightly narrower
//               maxHeight: '98vh',   // 🔥 almost full screen height
//               borderRadius: '12px',
//               boxShadow: '0 0 30px rgba(0,0,0,0.7)'
//             }}
//           />
//         </div>
//       )}

//     </div>
//   );
// };

// export default EventsCelebrations;































import React, { useState, useEffect, useCallback } from 'react';

import '../styles/EventCelebrations.css';


const getTodayKey = () => {
  const today = new Date();
  return `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
};

const EventsCelebrations = () => {
  const [festivals, setFestivals] = useState([]);
  const [activeTab, setActiveTab] = useState('events'); // 'events' or 'festivals'
  const [events, setEvents] = useState([]);
  const [todayFestival, setTodayFestival] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sendingId, setSendingId] = useState(null);
  const [sendingFest, setSendingFest] = useState(null);

  const [sentEmailIds, setSentEmailIds] = useState(() => {
    try {
      const stored = localStorage.getItem(`sent_emails_${getTodayKey()}`);
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  });

  const [sentFestivals, setSentFestivals] = useState(() => {
    try {
      const stored = localStorage.getItem(`sent_festivals_${getTodayKey()}`);
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  });

  const [previewImage, setPreviewImage] = useState(null);
  const [newFestival, setNewFestival] = useState({
    name: '',
    date: '',
    image: null
  });
  const [addingFestival, setAddingFestival] = useState(false);
  const [festivalFormError, setFestivalFormError] = useState('');
  const [fileInputKey, setFileInputKey] = useState(Date.now());


  const fetchEvents = useCallback(async () => {
    try {
      const res = await fetch('/gt-api/get_celebrations.php', {
        credentials: "include"
      });
      const data = await res.json();
      console.log("🔥 API RESPONSE:", data);
      if (data.success) setEvents(data.data);
    } catch (err) {
      console.error("Error fetching celebrations:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchEvents();
    const midnightCheck = setInterval(() => {
      const now = new Date();
      if (now.getHours() === 0 && now.getMinutes() === 0) {
        fetchEvents();
      }
    }, 60000);
    return () => clearInterval(midnightCheck);
  }, [fetchEvents]);

  useEffect(() => {
    fetch('/gt-api/get_festivals.php', {
      credentials: "include"
    })
      .then(res => res.json())
      .then(data => {
        console.log("FESTIVALS API DATA:", data);
        const list = data.festivals || data.data || [];
        setFestivals(list);
      })
      .catch(err => console.error("Error fetching festivals:", err));
  }, []);

  const checkIfFestivalIsToday = (festival, daysLeftVal, isTodayFlag) => {
    if (!festival) return false;
    if (isTodayFlag === true || daysLeftVal === 0) return true;

    if (festival.date) {
      const today = new Date();
      const currentDay = today.getDate();
      const currentMonth = today.getMonth(); // 0-indexed (0=Jan, 8=Sep)
      const monthNames = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
      const currentMonthName = monthNames[currentMonth];

      const dateLower = String(festival.date).trim().toLowerCase();

      // 1. Text Month Matching (e.g., "7th Sep", "7 Sep", "2nd to 10th Oct")
      if (dateLower.includes(currentMonthName) || (currentMonthName === "sep" && dateLower.includes("sept"))) {
        const rangeMatch = dateLower.match(/(\d+)\s*(?:st|nd|rd|th)?\s*to\s*(\d+)\s*(?:st|nd|rd|th)?/);
        if (rangeMatch) {
          const startDay = parseInt(rangeMatch[1], 10);
          const endDay = parseInt(rangeMatch[2], 10);
          if (currentDay >= startDay && currentDay <= endDay) {
            return true;
          }
        }

        const numbers = dateLower.match(/\d+/g);
        if (numbers) {
          for (let numStr of numbers) {
            const num = parseInt(numStr, 10);
            if (num === currentDay) {
              return true;
            }
          }
        }
      }

      // 2. Numeric Date Matching (e.g., "7-9-2026", "07-09-2026", "7/9/2026", "2026-09-07")
      const numMatch = dateLower.match(/^(\d{1,4})[-/.](\d{1,2})[-/.](\d{1,4})$/);
      if (numMatch) {
        let p1 = parseInt(numMatch[1], 10);
        let p2 = parseInt(numMatch[2], 10);
        let p3 = parseInt(numMatch[3], 10);

        let d, m;
        if (p1 > 31) {
          // YYYY-MM-DD
          m = p2; d = p3;
        } else {
          // DD-MM-YYYY
          d = p1; m = p2;
        }

        if (d === currentDay && m === (currentMonth + 1)) {
          return true;
        }
      }
    }

    if (typeof daysLeftVal === 'number' && daysLeftVal === 0) {
      return true;
    }

    return false;
  };

  useEffect(() => {
    fetch('/gt-api/get_upcoming_festival.php', {
      credentials: "include"
    })
      .then(res => res.json())
      .then(data => {
        console.log("UPCOMING FESTIVAL DATA:", data);
        const fest = data.festival || data.upcoming || (data.data && data.data[0]);
        if (fest) {
          const normalized = {
            ...fest,
            name: fest.name || fest.festival_name || fest.title || "Festival",
            image: fest.image || fest.img || fest.imageName || ""
          };
          const festIsToday = data.isToday === true || data.daysLeft === 0 || checkIfFestivalIsToday(normalized, data.daysLeft, data.isToday);
          if (festIsToday) {
            setTodayFestival(normalized);
          } else {
            setTodayFestival(null);
          }
        } else {
          setTodayFestival(null);
        }
      })
      .catch(err => {
        console.error("Error fetching today's festival:", err);
        setTodayFestival(null);
      });
  }, []);

  useEffect(() => {
    if (festivals.length > 0 && !todayFestival) {
      const foundToday = festivals.find(f => checkIfFestivalIsToday(f));
      if (foundToday) {
        setTodayFestival({
          ...foundToday,
          name: foundToday.name || foundToday.festival_name || foundToday.title || "Festival",
          image: foundToday.image || foundToday.img || foundToday.imageName || ""
        });
      }
    }
  }, [festivals, todayFestival]);

  // Handle Daily Birthday/Anniversary Email
  const handleSendEmail = async (emp) => {
    if (sentEmailIds.includes(emp.EmpId)) {
      alert(`Wish has already been sent to ${emp.fullName} today!`);
      return;
    }

    setSendingId(emp.EmpId);
    try {
      const response = await fetch('/gt-api/send_celebration_wish.php', {
        method: 'POST',
        credentials: "include",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: emp.EmailId,
          name: emp.fullName,
          type: emp.type,
          years: emp.years,
          imageName: eventImages[emp.EmpId] || ""
        }),
      });
      const result = await response.json();
      if (result.success) {
        alert(`Wish successfully sent to ${emp.fullName}!`);
        setSentEmailIds(prev => {
          const updated = [...prev, emp.EmpId];
          try {
            localStorage.setItem(`sent_emails_${getTodayKey()}`, JSON.stringify(updated));
          } catch (e) { console.error(e); }
          return updated;
        });
      } else {
        alert(`Failed: ${result.message}`);
      }
    } catch (error) {
      alert("Network error: Could not reach server.");
    } finally {
      setSendingId(null);
    }
  };

  // Handle Festival Broadcast Email to ALL Employees
  const handleSendFestival = async (fest) => {
    if (sentFestivals.includes(fest.name)) {
      alert(`${fest.name} wishes have already been sent to employees today!`);
      return;
    }

    if (!window.confirm(`Are you sure you want to send ${fest.name} wishes to ALL employees?`)) return;

    setSendingFest(fest.name);
    try {
      const response = await fetch('/gt-api/send_festival_wish.php', {
        method: 'POST',
        credentials: "include",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          festivalName: fest.name,
          imageName: fest.image || fest.img || fest.imageName || ""
        }),
      });
      const result = await response.json();
      if (result.success) {
        alert(`Success! Broadcast sent to ${result.sent} employees.`);
        setSentFestivals(prev => {
          const updated = [...prev, fest.name];
          try {
            localStorage.setItem(`sent_festivals_${getTodayKey()}`, JSON.stringify(updated));
          } catch (e) { console.error(e); }
          return updated;
        });
      } else {
        alert(`Error: ${result.message}`);
      }
    } catch (error) {
      alert("Network error: Could not reach server.");
    } finally {
      setSendingFest(null);
    }
  };

  // Handle Adding New Festival with Validation & Loading State
  const handleAddFestival = async () => {
    setFestivalFormError('');

    if (!newFestival.name || !newFestival.name.trim()) {
      const err = "Please enter the festival name.";
      setFestivalFormError(err);
      alert(err);
      return;
    }

    if (!newFestival.date || !newFestival.date.trim()) {
      const err = "Please enter the festival date (e.g., 7th Sep, 25th Dec).";
      setFestivalFormError(err);
      alert(err);
      return;
    }

    const monthNamesRegex = /\b(jan|january|feb|february|mar|march|apr|april|may|june?|july?|aug|august|sep|sept|september|oct|october|nov|november|dec|december)\b/i;
    if (!monthNamesRegex.test(newFestival.date.trim())) {
      const err = "Invalid Date Format! Strictly enter the date using month name (e.g., '7th Sep', '25th Dec', or '2nd to 10th Oct'). Do not use numeric date formats like '7-9-2026'.";
      setFestivalFormError(err);
      alert(err);
      return;
    }

    if (!newFestival.image) {
      const err = "Please select an image file for the festival.";
      setFestivalFormError(err);
      alert(err);
      return;
    }

    if (newFestival.image && !newFestival.image.type.startsWith('image/')) {
      const err = "Invalid file type. Selected file must be an image (PNG, JPG, JPEG, WEBP, etc.).";
      setFestivalFormError(err);
      alert(err);
      return;
    }

    if (newFestival.image && newFestival.image.size > 10 * 1024 * 1024) {
      const err = "Image file is too large. Maximum allowed size is 10MB.";
      setFestivalFormError(err);
      alert(err);
      return;
    }

    setAddingFestival(true);

    try {
      const formData = new FormData();
      formData.append("name", newFestival.name.trim());
      formData.append("date", newFestival.date.trim());
      formData.append("image", newFestival.image);

      const res = await fetch('/gt-api/add_festival.php', {
        method: 'POST',
        credentials: "include",
        body: formData
      });

      const result = await res.json();

      if (result.success) {
        alert("Festival added successfully!");
        setNewFestival({ name: '', date: '', image: null });
        setFileInputKey(Date.now());
        setFestivalFormError('');

        fetch('/gt-api/get_festivals.php', { credentials: "include" })
          .then(r => r.json())
          .then(data => {
            const list = data.festivals || data.data || [];
            setFestivals(list);
          })
          .catch(e => console.error("Error refreshing festivals:", e));
      } else {
        const errorMsg = result.message || result.error || "Failed to add festival. Please check your inputs and try again.";
        setFestivalFormError(errorMsg);
        alert(`Error: ${errorMsg}`);
      }
    } catch (error) {
      console.error("Network/Server error adding festival:", error);
      const connErr = "Network error: Unable to reach server. Please try again.";
      setFestivalFormError(connErr);
      alert(connErr);
    } finally {
      setAddingFestival(false);
    }
  };

  const [eventImages, setEventImages] = useState({});
  useEffect(() => {
    if (events.length > 0) {
      const imagesMap = {};

      events.forEach(emp => {
        if (emp.isBirthday) {
          const birthdayImages = [
            "Birthday card 1.jpg",
            "Birthday card 2.jpg",
            "Birthday card 3.png",
            "Birthday card 4.png",
            "Birthday card 5.png",
            "Birthday card 6.jpg",
            "Birthday card 7.jpg",
            "Birthday card 8.jpg",
            "Birthday card 9.jpg"
          ];

          const randomIndex = Math.floor(Math.random() * birthdayImages.length);
          imagesMap[emp.EmpId] = birthdayImages[randomIndex];

        } else {
          const year = emp.years;

          if (year >= 5) imagesMap[emp.EmpId] = "anniversary_5.png";
          else if (year === 4) imagesMap[emp.EmpId] = "anniversary_4.png";
          else if (year === 3) imagesMap[emp.EmpId] = "anniversary_3.png";
          else if (year === 2) imagesMap[emp.EmpId] = "anniversary_2.png";
          else imagesMap[emp.EmpId] = "anniversary_1.png";
        }
      });

      setEventImages(imagesMap);
    }
  }, [events]);



  return (
    <div className="okr-glass-card" style={{ padding: '25px', color: '#fff' }}>
      <style>{`
        @keyframes btnSpin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        .btn-spinner {
          width: 14px;
          height: 14px;
          border: 2px solid rgba(255,255,255,0.4);
          border-top: 2px solid #ffffff;
          border-radius: 50%;
          animation: btnSpin 0.8s linear infinite;
          display: inline-block;
        }
      `}</style>
      {/* Tab Header */}
      <div style={{ display: 'flex', gap: '15px', marginBottom: '25px', borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '15px' }}>
        <button
          onClick={() => setActiveTab('events')}
          style={{
            background: activeTab === 'events' ? '#2196F3' : 'transparent',
            color: '#fff', border: '1px solid #2196F3', padding: '8px 16px', borderRadius: '20px', cursor: 'pointer', transition: '0.3s'
          }}>📅 Daily Events</button>
        <button
          onClick={() => setActiveTab('festivals')}
          style={{
            background: activeTab === 'festivals' ? '#2196F3' : 'transparent',
            color: '#fff', border: '1px solid #2196F3', padding: '8px 16px', borderRadius: '20px', cursor: 'pointer', transition: '0.3s'
          }}>🏮 Festival Broadcast</button>
      </div>

      {activeTab === 'events' ? (
        <>
          <h2 className="blue-gradient-text">🎉 Today's Events</h2>
          <p style={{ opacity: 0.6 }}>Birthdays, work anniversaries, and festivals for today.</p>


          {loading ? <p>Loading...</p> : (
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
              gap: '20px',
              marginTop: '20px'
            }}>

              {todayFestival && (
                <div
                  key={`fest-${todayFestival.id || todayFestival.name}`}
                  style={{
                    background: 'rgba(255, 152, 0, 0.12)',
                    padding: '20px',
                    borderRadius: '12px',
                    borderLeft: '4px solid #ff9800',
                    border: '1px solid rgba(255, 152, 0, 0.3)'
                  }}
                >
                  {todayFestival.image && (
                    <img
                      src={`/gt-api/assets/${todayFestival.image}`}
                      alt={todayFestival.name}
                      onClick={() => setPreviewImage(todayFestival.image)}
                      style={{
                        width: '100%',
                        height: '200px',
                        objectFit: 'cover',
                        borderRadius: '10px',
                        marginBottom: '10px',
                        cursor: 'pointer'
                      }}
                    />
                  )}

                  <div style={{ fontSize: '1.5rem' }}>🏮</div>

                  <h4 style={{ margin: '10px 0 5px 0' }}>
                    {todayFestival.name}
                  </h4>

                  <p style={{
                    color: '#ff9800',
                    fontSize: '0.85rem',
                    fontWeight: 'bold'
                  }}>
                    FESTIVAL TODAY! 🎉
                  </p>

                  <p style={{ fontSize: '0.75rem', opacity: 0.5 }}>
                    Company Festival
                  </p>

                  <button
                    onClick={() => handleSendFestival(todayFestival)}
                    disabled={sendingFest === todayFestival.name || sentFestivals.includes(todayFestival.name)}
                    style={{
                      marginTop: '15px',
                      width: '100%',
                      padding: '9px 12px',
                      background: sentFestivals.includes(todayFestival.name)
                        ? '#2e7d32'
                        : sendingFest === todayFestival.name
                          ? '#555'
                          : '#ff9800',
                      border: 'none',
                      borderRadius: '6px',
                      color: '#fff',
                      cursor: (sendingFest === todayFestival.name || sentFestivals.includes(todayFestival.name)) ? 'not-allowed' : 'pointer',
                      fontWeight: 'bold',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px',
                      transition: 'background 0.3s'
                    }}
                  >
                    {sendingFest === todayFestival.name ? (
                      <>
                        <span className="btn-spinner"></span>
                        <span>BROADCASTING...</span>
                      </>
                    ) : sentFestivals.includes(todayFestival.name) ? (
                      "SENT ALREADY ✅"
                    ) : (
                      "SEND TO ALL ✉️"
                    )}
                  </button>
                </div>
              )}

              {events.length > 0 && events.map((emp) => {

                const getEventImage = (emp) => {
                  if (emp.isBirthday) {
                    const birthdayImages = [
                      "Birthday card 1.jpg",
                      "Birthday card 2.jpg",
                      "Birthday card 3.png",
                      "Birthday card 4.png",
                      "Birthday card 5.png",
                      "Birthday card 6.jpg",
                      "Birthday card 7.jpg",
                      "Birthday card 8.jpg",
                      "Birthday card 9.jpg"
                    ];
                    const randomIndex = Math.floor(Math.random() * birthdayImages.length);
                    return birthdayImages[randomIndex];
                  } else {
                    const year = emp.years;
                    if (year >= 5) return "anniversary_5.png";
                    if (year === 4) return "anniversary_4.png";
                    if (year === 3) return "anniversary_3.png";
                    if (year === 2) return "anniversary_2.png";
                    return "anniversary_1.png";
                  }
                };

                const imageName = getEventImage(emp);

                return (
                  <div
                    key={emp.EmpId}
                    style={{
                      background: 'rgba(255,255,255,0.07)',
                      padding: '20px',
                      borderRadius: '12px',
                      borderLeft: emp.isBirthday ? '4px solid #ff4081' : '4px solid #00bcd4'
                    }}
                  >

                    {/* 🔥 IMAGE ADDED */}
                    <img
                      src={`/gt-api/assets/${eventImages[emp.EmpId]}`}
                      alt={emp.fullName}
                      onClick={() => setPreviewImage(eventImages[emp.EmpId])}
                      style={{
                        width: '100%',
                        height: '200px',
                        objectFit: 'cover',
                        borderRadius: '10px',
                        marginBottom: '10px',
                        cursor: 'pointer' // 🔥 add this
                      }}
                    />

                    <div style={{ fontSize: '1.5rem' }}>
                      {emp.isBirthday ? '🎂' : '🎊'}
                    </div>

                    <h4 style={{ margin: '10px 0 5px 0' }}>
                      {emp.fullName}
                    </h4>

                    <p style={{
                      color: emp.isBirthday ? '#ff4081' : '#00bcd4',
                      fontSize: '0.85rem',
                      fontWeight: 'bold'
                    }}>
                      {emp.isBirthday
                        ? "IT'S THEIR BIRTHDAY!"
                        : `COMPLETED ${emp.years} YEAR(S)`
                      }
                    </p>

                    <p style={{ fontSize: '0.75rem', opacity: 0.5 }}>
                      {emp.Department} Team
                    </p>

                    <button
                      onClick={() => handleSendEmail(emp)}
                      disabled={sendingId === emp.EmpId || sentEmailIds.includes(emp.EmpId)}
                      style={{
                        marginTop: '15px',
                        width: '100%',
                        padding: '9px 12px',
                        background: sentEmailIds.includes(emp.EmpId)
                          ? '#2e7d32'
                          : sendingId === emp.EmpId
                            ? '#555'
                            : '#2196F3',
                        border: 'none',
                        borderRadius: '6px',
                        color: '#fff',
                        cursor: (sendingId === emp.EmpId || sentEmailIds.includes(emp.EmpId)) ? 'not-allowed' : 'pointer',
                        fontWeight: '600',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px',
                        transition: 'background 0.3s'
                      }}
                    >
                      {sendingId === emp.EmpId ? (
                        <>
                          <span className="btn-spinner"></span>
                          <span>SENDING...</span>
                        </>
                      ) : sentEmailIds.includes(emp.EmpId) ? (
                        "SENT ALREADY ✅"
                      ) : (
                        "WISH THEM ✉️"
                      )}
                    </button>

                  </div>
                );

              })}

              {events.length === 0 && !todayFestival && (
                <p style={{ opacity: 0.5 }}>No events today.</p>
              )}

            </div>
          )}
        </>
      ) : (
        <>
          <h2 className="blue-gradient-text">🏮 Festival Broadcast</h2>
          <div className="add-festival-container" style={{ flexDirection: 'column', alignItems: 'stretch' }}>
            <div style={{ display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'wrap' }}>
              <input
                type="text"
                placeholder="Festival Name (e.g. Holi)"
                value={newFestival.name}
                disabled={addingFestival}
                onChange={(e) => {
                  setFestivalFormError('');
                  setNewFestival(prev => ({ ...prev, name: e.target.value }));
                }}
              />

              <input
                type="text"
                placeholder="Date (e.g. 25th Dec)"
                value={newFestival.date}
                disabled={addingFestival}
                onChange={(e) => {
                  setFestivalFormError('');
                  setNewFestival(prev => ({ ...prev, date: e.target.value }));
                }}
              />

              <input
                key={fileInputKey}
                type="file"
                accept="image/*"
                disabled={addingFestival}
                onChange={(e) => {
                  setFestivalFormError('');
                  setNewFestival(prev => ({ ...prev, image: e.target.files[0] || null }));
                }}
              />

              <button
                className="add-festival-btn"
                onClick={handleAddFestival}
                disabled={addingFestival}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  opacity: addingFestival ? 0.7 : 1,
                  cursor: addingFestival ? 'not-allowed' : 'pointer'
                }}
              >
                {addingFestival ? (
                  <>
                    <span className="btn-spinner"></span>
                    <span>ADDING FESTIVAL...</span>
                  </>
                ) : (
                  "➕ Add Festival"
                )}
              </button>
            </div>

            {festivalFormError && (
              <div style={{
                marginTop: '10px',
                padding: '8px 12px',
                background: 'rgba(244, 67, 54, 0.15)',
                border: '1px solid #f44336',
                borderRadius: '6px',
                color: '#ff6b6b',
                fontSize: '13px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                ⚠️ {festivalFormError}
              </div>
            )}

            <p style={{ fontSize: '0.75rem', opacity: 0.8, marginTop: '8px', marginBottom: 0, color: '#ffb74d' }}>
              💡 <strong>Date Format Rule:</strong> Enter date with month name (e.g., <code>7th Sep</code>, <code>25th Dec</code>, <code>2nd to 10th Oct</code>). Do not enter numeric dates like <code>7-9-2026</code>.
            </p>
          </div>
          <p style={{ opacity: 0.6 }}>Send festival greetings to all employees at once.</p>

          <div className="festival-grid" style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
            gap: '15px',
            marginTop: '20px'
          }}>
            {festivals.map((fest) => (
              <div key={fest.name} style={{
                background: 'rgba(255,255,255,0.07)',
                padding: '15px',
                borderRadius: '10px',
                textAlign: 'center',
                border: '1px solid rgba(255,255,255,0.1)'
              }}>

                <img
                  src={`/gt-api/assets/${fest.image}`}
                  alt={fest.name}
                  onClick={() => setPreviewImage(fest.image)}
                  style={{
                    width: '100%',
                    height: '120px',
                    objectFit: 'cover',
                    borderRadius: '8px',
                    marginBottom: '10px',
                    cursor: 'pointer'
                  }}
                />

                <h4>{fest.name}</h4>
                <p>{fest.date}</p>

                {/* 🔥 ADD BUTTON RIGHT HERE */}
                <button
                  onClick={() => handleSendFestival(fest)}
                  disabled={sendingFest === fest.name || sentFestivals.includes(fest.name)}
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    background: sentFestivals.includes(fest.name)
                      ? '#2e7d32'
                      : sendingFest === fest.name
                        ? '#555'
                        : '#4CAF50',
                    border: 'none',
                    borderRadius: '6px',
                    color: '#fff',
                    cursor: (sendingFest === fest.name || sentFestivals.includes(fest.name)) ? 'not-allowed' : 'pointer',
                    fontWeight: '600',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    transition: 'background 0.3s'
                  }}
                >
                  {sendingFest === fest.name ? (
                    <>
                      <span className="btn-spinner"></span>
                      <span>BROADCASTING...</span>
                    </>
                  ) : sentFestivals.includes(fest.name) ? (
                    "SENT ALREADY ✅"
                  ) : (
                    "SEND TO ALL ✉️"
                  )}
                </button>
                <label className="custom-file-upload">
                  📤 Change Image
                  <input
                    type="file"
                    onChange={async (e) => {
                      const file = e.target.files[0];
                      if (!file) return;

                      const formData = new FormData();
                      formData.append("id", fest.id);
                      formData.append("image", file);

                      const res = await fetch('/gt-api/update_festival.php', {
                        method: 'POST',
                        credentials: "include",
                        body: formData
                      });

                      const result = await res.json();

                      if (result.success) {
                        alert("Updated!");
                        window.location.reload();
                      }
                    }}
                  />
                </label>
                {/* 🔥 ADD DELETE BUTTON HERE */}
                <button
                  onClick={async () => {
                    if (!window.confirm("Delete this festival?")) return;

                    const res = await fetch('/gt-api/delete_festival.php', {
                      method: 'POST',
                      credentials: "include",
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({
                        id: fest.id,
                        image: fest.image
                      })
                    });

                    const result = await res.json();

                    if (result.success) {
                      alert("Deleted!");
                      setFestivals(prev => prev.filter(f => f.id !== fest.id));
                    }
                  }}
                  style={{
                    marginTop: '8px',
                    padding: '5px 10px',
                    background: 'rgba(229,57,53,0.15)',
                    border: '1px solid #e53935',
                    borderRadius: '20px',
                    color: '#ff6b6b',
                    cursor: 'pointer',
                    fontSize: '12px',
                    width: 'auto',
                    display: 'inline-block'
                  }}
                >
                  🗑 Delete
                </button>


              </div>
            ))}

            {previewImage && (
              <div
                className="image-preview-overlay"
                onClick={() => setPreviewImage(null)}   // 🔥 CLOSE ON CLICK ANYWHERE
              >
                <span
                  className="close-btn"
                  onClick={() => setPreviewImage(null)}
                >
                  ✖
                </span>

                <img
                  src={`/gt-api/assets/${previewImage}`}
                  className="preview-image"
                  onClick={(e) => e.stopPropagation()}  // 🔥 PREVENT IMAGE CLICK FROM CLOSING
                />
              </div>
            )}
          </div>
        </>
      )
      }


      {previewImage && (
        <div
          onClick={() => setPreviewImage(null)} // 🔥 click outside closes
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0,0,0,0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999
          }}
        >

          {/* ❌ CLOSE BUTTON */}
          <span
            onClick={() => setPreviewImage(null)}
            style={{
              position: 'absolute',
              top: '20px',
              right: '30px',
              fontSize: '28px',
              color: '#fff',
              cursor: 'pointer'
            }}
          >
            ✖
          </span>

          {/* IMAGE */}
          <img
            src={`/gt-api/assets/${previewImage}`}
            alt="preview"
            onClick={(e) => e.stopPropagation()}
            style={{
              maxWidth: '80%',     // slightly narrower
              maxHeight: '98vh',   // 🔥 almost full screen height
              borderRadius: '12px',
              boxShadow: '0 0 30px rgba(0,0,0,0.7)'
            }}
          />
        </div>
      )}

    </div>
  );
};

export default EventsCelebrations;

